// This file contains various helper functions which are used in the other JS files included in the bundle.
// import * as Sentry from "@sentry/browser";

export const helpers = {
    throttle: (fn, delay = 200) => {
        // This function helps throttle various listeners that otherwise would be called with too high frequency
        let hold = false;
        let trail;
        let timeout = () => {
            if (trail !== undefined) {
                fn.apply(trail[0], trail[1]);
                trail = undefined;
                setTimeout(timeout, delay)
            } else {
                hold = false;
            }
        }
        return (...args) => {
            if (!hold) {
                fn.apply(this, args);
                hold = true;
                setTimeout(timeout, delay);
            } else {
                trail = [this, args];
            }
        }
    },
    pageHistory: { // if document.referrer somehow can take page reload into account that would be cleaner
        get: () => {
            let data = localStorage.getItem("page_history");
            let returnValue;
            if (!data) {
                return false;
            }
            else {
                try {
                    returnValue = JSON.parse(data);
                }
                catch (e) {
                    return false;
                }
            }
            return returnValue;
        },
        set: () => {
            let currentHistory = {previous_page: false};
            let previousHistory = helpers.pageHistory.get();
            if (previousHistory && Object.hasOwn(previousHistory, "current_page")) {
                currentHistory.previous_page = previousHistory.current_page;
            }
            currentHistory.current_page = window.location.pathname;
            localStorage.setItem("page_history", JSON.stringify(currentHistory));
        }
    },
    getWindowWidth: () => {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    },
    isSmallDevice: () => {
        // Checks if the visitor is currently using a smaller device/screen size
        let windowWidth = helpers.getWindowWidth();
        return windowWidth > 991 ? false : true;
    },
    isURL: (url) => {
        // Valides if a string is a valid URL
        const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
        return regexp.test(url);
    },
    scrollWindow: (selector, margin) => {
        // Scrolls the window to any given selector
        if (!$(selector).length) {
            return;
        }
        margin = margin === undefined ? $("#main-header").outerHeight() : margin;
        let position = $(selector).offset().top - margin;
        position = position < 0 ? 0 : position;
        $("html").animate({ scrollTop: position }, 400, "swing");
    },
    removePriceDecimals: (selector) => {
        // Removes the trailing zero-decimals (,00) in the content of any given selector(s)
        $(selector).each(function () {
            let price = $(this);
            if (!price.length) { return; }
            if (!price.html().length) { return; }
            price.html(price.html().replace(',00', ''));
        });
    },
    swipe: {
        // Enables a callback whenever a visitor swipes a cetrain selector (left or right). Mainly used to listen for swipes from phones and other touch devices
        xDown: null,
        yDown: null,
        addCallback: (el, callbacks) => {
            el.addEventListener('touchstart', function (e) {
                helpers.swipe.xDown = e.touches[0].clientX;
                helpers.swipe.yDown = e.touches[0].clientY;
            }, false);
            el.addEventListener('touchmove', function (e) {
                if (!helpers.swipe.xDown || !helpers.swipe.yDown) {
                    return;
                }
                let xUp = e.touches[0].clientX;
                let yUp = e.touches[0].clientY;
                let xDiff = helpers.swipe.xDown - xUp;
                let yDiff = helpers.swipe.yDown - yUp;
                if (Math.abs(xDiff) > Math.abs(yDiff)) {
                    if (xDiff > 0) {
                        if (callbacks.hasOwnProperty("left")) {
                            callbacks.left();
                        }
                    }
                    else {
                        if (callbacks.hasOwnProperty("right")) {
                            callbacks.right();
                        }
                    }
                }
                else {
                    if (yDiff > 0) {
                        if (callbacks.hasOwnProperty("up")) {
                            callbacks.up();
                        }
                    }
                    else {
                        if (callbacks.hasOwnProperty("down")) {
                            callbacks.down();
                        }
                    }
                }
                helpers.swipe.xDown = null;
                helpers.swipe.yDown = null;
            }, false);
        }
    },
    getParameterByName: (name, url = window.location.href) => {
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        let results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    getCountrySuffix: () => {
        let suffix = 'se';
        if (prestashop.urls.base_url !== 'https://www.dpj.se/') {
            suffix = prestashop.urls.base_url.slice(-3).replace("/", "");
        }
        return suffix;
    },
    /*isVisible: (selector, partial) => {
        // Checks if any given selector currently is visible within the window
        let $t            = $(selector),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;
        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    },*/

    /**
     * listener to animate accordions.
     * will target class "accordion"
     * will animate direct decendant sub-node with class "accordion__content".
     */
    accordionInit: () => {
        let sel
        if (helpers.isSmallDevice()) {
            sel = ".accordion"
        } else {
            sel = ".accordion:not(.accordion--only-mobile)"
        }

        $(sel).on("click", (ev) => {
            const t = ev.currentTarget
            $(t).toggleClass("accordion--open")
            const el = $(t).find('.accordion__content').get(0)
            $(el).animate({
                height: "toggle"
            }, 240);
        })

        $(sel + ":not(.accordion--open)").find('.accordion__content').animate({
            height: "toggle"
        }, 0);
    },

    /**
     *
     * - RESOLVE object example:
     *  ```
     *  {
     *    "provider": 1,
     *    "city": "Stockholm",
     *    "region": "Stockholm County",
     *    "country": "SE"
     *  }
     * ```
     * - REJECT object example:
     *  ```
     *  {
     *      provider: 0,
     *      status: 400
     *      error: "Token is not allowed access from this source. Please check your token security rules."
     *  }
     * ```
    */
    getLocationData: () => {
        return new Promise((resolve, reject) => {
            // - HELPERS - //

            /** provides xhr.onerror callback for all providers
             * @param {function} reject
             * @param {number} id
             * @param {string} error
             * @returns void
             */
            const onErr = (reject, id, error = "failed to get location") => () => {
                reject({ provider: id, error })
            }

            /**
             * univeral resolve helper for all providers
             * @param {function} resolve
             * @param {function} reject
             * @param {number} id
             * @param {object} res
             * @param {number} res.status
             * @param {string} res.error
             * @param {string} res.city
             * @param {string} res.region
             * @param {string} res.country
             * @returns void
             */
            const resolveHelper = (resolve, reject, id, res) => {
                if (res.status === 200) {
                    resolve({
                        provider: id,
                        city: res.city,
                        region: res.region,
                        country: res.country
                    })
                }
                else onErr(reject, id, res.error)
            }

            /**
             * creates and sends xhr request for provider
             * @param {number} id
             * @param {string} url
             * @param {function} transformer - transforms xhr response to object required by resolveHelper
             * @returns void
             */
            const requestHelper = (id, url, transformer) => {
                let xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.onload = () => {
                    resolveHelper(resolve, reject, id, transformer(xhr))
                }
                xhr.onerror = onErr(reject, id)
                xhr.send();
            }

            // - SERCIE PROVIDERS - //
            const providers = [
                (id) => {
                    requestHelper(id, 'https://ipapi.co/json/',
                        (xhr) => {
                            const json = JSON.parse(xhr.responseText)
                            return {
                                status: xhr.status,
                                error: json.error,
                                city: json.city,
                                region: json.region,
                                country: json.country
                            }
                        })
                },
                (id) => {
                    requestHelper(id, 'https://ipinfo.io/json?token=a81faa9437ada6',
                        (xhr) => {
                            const json = JSON.parse(xhr.responseText)
                            return {
                                status: xhr.status,
                                error: json.error,
                                city: json.city,
                                region: json.region,
                                country: json.country
                            }
                        })
                }
            ]

            // - EXECUTION - //
            // invoke a "random" provider
            const providerId = new Date().getMilliseconds() % providers.length
            providers[providerId](providerId)
        })

    },
    /**
     * simple promise that will reject after given number of ms.
     *
     * race this promise with other promises to set a timeout.
     *
     * @example
     * Promise.race([prom1, prom2, helpers.timeoutPromise(5000)])
     *  .then((res) => {
     *     // do something with res
     * })
     * .catch((err) => {
     *    // do something with err
     * })
     *
     * @param {number} ms  - default 2000ms
     * @returns
     */
    timeoutPromise: (ms = 2000) => {
        return new Promise((_, reject) => {
            setTimeout(() => {
                reject("timeout")
            }, ms);
        })
    },
    /**
    * @param {number} variationId
    * @returns Boolean - true if supplied symplify test `variantionId` is active, false if not.
    * @description checks if the given symplify variation is active. If symplify is not loaded it will return false.
    */
    isSymplifyVariation: (variationId) => {
        try {
            // DEBUG: remove next line
            // return true;
            if (typeof symplify !== 'object' || typeof symplify.getActivatedProjects !== 'function') {
                return false;
            }
            const activatedProjects = symplify.getActivatedProjects();
            console.debug("activatedProjects", activatedProjects, "variationId", variationId);
            if (!activatedProjects.some(p => p.variationId === variationId)) {
                return false;
            }
            return true;

        } catch (error) {
            console.error("isSymplifyVariation failed", error);
            // Sentry.withScope(function (scope) {
            //     scope.setContext("helpers/isSymplifyVariation", { variationId })
            //     Sentry.captureException(error);
            // });
        }

    },

    /**
     * @typedef {Object} SymplifyVariationCallback
     * @property {number} id
     * @property {Function} cb
     */

    /**
     * @typedef {Object} SymplifyProject
     * @property {number} projectId
     * @property {Array<SymplifyVariationCallback>} variationCallbacks
     * @property {Function} fallback
     * @property {number} timeoutMs
     * @property {number} fallbackTimeout - internal use
     * @property {boolean} done - internal use
     * @property {boolean} timedOut - internal use
     * @property {number} addedTime - internal use
     * @property {number} variationIdActive - internal use - 0 signals fallback was used.
     */

    symplifyProjects: [],
    /**
     * @param {SymplifyProject} project
     * @description Adds callbacks to be ran when symplify test is active.
     * - If we are in a variation that is not in the list, the fallback function will be called. ,
     * - If the timeout is reached, the fallback function will be called.
     *
     * @example
        helpers.symplifyAddProject({
            projectId: 192526712,
            variationCallbacks: [
                { id: 11323080, cb: product.init_v2 },
                { id: 11323081, cb: product.init_v3 }],
            fallback: product.init_v1,
            timeoutMs: 500
        });
     */
    symplifyAddProject: (project) => {
        // console.log("[helpers/symplifyAddProject]", project)
        if (!project
            || typeof project.projectId !== 'number'
            || !Array.isArray(project.variationCallbacks)
            || typeof project.fallback !== 'function'
            || typeof project.timeoutMs !== 'number') {
            console.error("symplifyAddProject called with invalid arguments.");
            // Sentry.withScope(function (scope) {
            //     scope.setLevel("error");
            //     scope.setContext("helpers/symplifyAddProject", project)
            //     Sentry.captureMessage("symplifyAddProject called with invalid arguments.");
            // });
            return;
        }

        // add to callbacks array
        project.fallbackTimeout = fallbackTimeout;
        project.done = false;
        project.timedOut = false;
        project.variationIdActive = null;
        project.addedTime = Date.now();
        helpers.symplifyProjects.push(project);

        // TIMEOUT behavior
        const fallbackTimeout = setTimeout(() => {
            if (project.done) {
                return;
            }
            // look for symplify object and get activated projects
            let activatedProjects = []
            if (typeof symplify !== 'undefined' && typeof symplify.getActivatedProjects !== 'undefined') {
                activatedProjects = symplify.getActivatedProjects().filter(p => p.projectId === project.projectId && !p.done);
            }
            // if we have matching projects, run the callbacks
            if (activatedProjects.length) {
                activatedProjects.forEach(symProj => {
                    helpers.symplifySetActive(symProj.projectId, symProj.variationId);
                    project.timedOut = true;
                    const msg = `Timeout reached, but project is active. Running callbacks.\n to avoid waiting for timeout, run "dpj.helpers.symplifyRunVariationCallbacks(${symProj.projectId},${symProj.variationId})" in the symplify test code.`;
                    console.debug(msg);
                    // Sentry.withScope(function (scope) {
                    //     scope.setLevel("info");
                    //     scope.setContext("helpers/symplifyAddCallback", { project: project, symplify: symProj })
                    //     Sentry.captureMessage("symplify project timed out. Running callbacks based on 'symplify.getActivatedProjects()'");
                    // });
                });
                return;
            }
            // if we have no matching projects, run the fallback
            project.fallback();
            project.timedOut = true;
            project.done = true;
            project.variationIdActive = 0;
        }, project.timeoutMs);


    },
    /**
     * @param {number} projectId
     * @param {number} variationId
     * @description Runs the callbacks for the given `projectId` and `variationId`. It is meant to be called from the symplify test tool (or other external scripts).
     * @example // run in symplify test tool
     * window.dpj.helpers.symplifyRunCallbacks(192526712,11323080);
     */
    symplifySetActive: (projectId, variationId) => {
        // console.log("[helpers/symplifySetActive]", projectId, variationId)
        const projects = helpers.symplifyProjects.filter(p => p.projectId === projectId); // get project callbacks

        // clear timeout and check for multiple activations of different variations on the same project
        projects.forEach(proj => {
            clearTimeout(proj.fallbackTimeout);
            if (proj.variationIdActive !== null && variationId !== proj.variationIdActive) {
                if (proj.timedOut) {
                    console.error(`[symplifyRunVariationCallbacks] Project ${projectId} timed out and activated ${proj.variationIdActive} (0 = fallback) but was activated after ${Date.now() - proj.addedTime}ms with a different variant (${variationId}). This WILL result in bad test data. Consider increasing the timeout. Current timeout is ${proj.timeoutMs}ms`);
                    // Sentry.withScope(function (scope) {
                    //     scope.setContext("helpers/symplifySetActive", { ...proj, timeSpent: Date.now() - proj.addedTime })
                    //     scope.setLevel("warning");
                    //     Sentry.captureMessage("symplify timed out and used the fallback variation. It was later called with a differrent variation.");
                    // });
                } else {
                    console.error(`[symplifyRunVariationCallbacks] Project ${projectId} was activated with multiple variations. Active variation is ${proj.variationIdActive} but it was called again with a different variant (${variationId}). This WILL likely result in bad test data. Current timeout is ${proj.timeoutMs}ms`);
                    // Sentry.withScope(function (scope) {
                    //     scope.setContext("helpers/symplifySetActive", { ...proj, timeSpent: Date.now() - proj.addedTime })
                    //     scope.setLevel("warning");
                    //     Sentry.captureMessage("symplifySetActive called with multiple variations on the same project.");
                    // });
                }
                return;
            }
            if (proj.done) {
                return;
            }

            // if we have a matching project, run the callbacks
            proj.variationIdActive = variationId;
            proj.done = true;
            let foundActive = false;
            proj.variationCallbacks.forEach(v => {
                if (v.id === variationId) {
                    foundActive = true;
                    // Sentry.setContext("symplifyProject-" + projectId, { projectId, variationId });
                    v.cb();
                }
            });
            if (!foundActive) {
                // Sentry.setContext("symplifyProject-" + projectId, { projectId, variationId: "fallback" });
                // Sentry.withScope(function (scope) {
                // scope.setLevel("warning");
                // Sentry.captureMessage("symplifySetActive called with a variation that is not in the project.");
                // });
                proj.fallback();
            }
        })
    },
    /**
    * Sends an email alert to the developers with given body.
    * Recipients are defined in `/misc/postmail.php`
    *
    * if body has a `subject` property, it will be used as the email subject.
    *
    * if body has a `sender` property, it will be used as the email sender.
    *
    * @param {any} body - The body of the email. (postmail.php)
    * @param {Error?} err - Optional error object to be sent in the email.
    */
    alertEmail: (body, err) => {
        if (typeof body === 'string') {
            body = { msg: body }
        }
        // extract data from error object
        if (err) {
            body.err = {
                name: err.name,
                message: err.message
                // excluding the stack as it is usually not very useful in this context. Include needed context on body where you are calling this function.
            };
        }
        body.id = "2a0a171a-f25b-4c9c-9c1d-791563c84cdb";
        console.debug("alertEmail", body)
        fetch("/misc/postmail.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then(data => console.debug("alertEmail OK", data))
            .catch(error => console.error("alertEmail ERR", error))

        // Sentry.withScope(function (scope) {
        //     scope.setContext("helpers/alertEmail", body)
        //     Sentry.captureMessage("alertEmail called");
        // });
    },

    /**
     * Run a function that can fail and capture the error with Sentry.
     *
     * @param {Function} fn - function that takes no arguments and can throw an error.
     * @param {string[]?} fingerprint - Used to group errors in Sentry, null uses default settings.
     * @returns bool - true if the function ran without errors, false if an error was caught.
     */
    tryCatchCapture: (fn, fingerprint = null) => {
        try {
            fn();
            return true;
        } catch (error) {
            // if (fingerprint === null) {
            // Sentry.captureException(error);
            // } else {
            // Sentry.withScope(function (scope) {
            // scope.setFingerprint(fingerprint);
            // scope.captureException(error, fingerprint);
            // })
            // }
            console.error("tryCatchCapture failed", error, "\nfingerprint", fingerprint);
            return false;
        }
    },

    /**
     * wrap a function that can fail and log the error. 
     * e.g. functions that are used in event listeners.
     *
     * @param {Function} fn - function that takes no arguments and can throw an error.
     * @returns bool - true if the function ran without errors, false if an error was caught.
     */
    try: (fn) => {
        if (fn.name === '') {
            console.debug("try wrapped anonymous function", fn);
        } else {
            console.debug("try wrapped function", fn.name, fn);
        }
        return (...args) => {
            try {
                console.debug("try", fn.name, args, "running");
                return fn(...args);
            } catch (error) {
                console.error("try", fn.name, args, "failed", error);
                return false;
            }
        }
    }
}